import { PromiseToPay, Receipt } from "@/types/payments";

/**
 * Mock Promise to Pay data for testing
 */
export const mockPromises: PromiseToPay[] = [
  {
    id: 1,
    customerId: 1,
    promisedDate: new Date("2025-01-15"),
    promisedAmount: 1250.0,
    status: "Pending",
    promisedTransactions: [
      {
        transactionId: 1,
        transactionNumber: "INV-2024-001",
        promisedAmount: 500.0,
        priority: 1,
        currentBalance: 500.0,
      },
      {
        transactionId: 3,
        transactionNumber: "INV-2024-003",
        promisedAmount: 450.0,
        priority: 2,
        currentBalance: 450.0,
      },
      {
        transactionId: 5,
        transactionNumber: "INV-2024-005",
        promisedAmount: 300.0,
        priority: 3,
        currentBalance: 300.0,
      },
    ],
  },
  {
    id: 2,
    customerId: 2,
    promisedDate: new Date("2025-01-20"),
    promisedAmount: 800.0,
    status: "Pending",
    promisedTransactions: [
      {
        transactionId: 10,
        transactionNumber: "INV-2024-010",
        promisedAmount: 800.0,
        priority: 1,
        currentBalance: 800.0,
      },
    ],
  },
];

/**
 * Mock Receipt data for testing (matching promise-001)
 */
export const mockReceiptsWithPromise: Receipt[] = [
  {
    id: 1,
    receiptNumber: "RCP-2025-001",
    customerId: 1,
    customerName: "ABC Company Ltd",
    customerAccountNumber: "ACC-001",
    receiptDate: new Date("2025-01-15"),
    receivedAmount: 1250.0,
    allocatedAmount: 0,
    unappliedAmount: 1250.0,
    currency: "GBP",
    allocationStatus: "unallocated",
    reconciliationStatus: "pending",
    paymentMethod: "bank_transfer",
    paymentReference: "BACS-12345",
    financeSystemId: "FS-001",
    importedAt: new Date("2025-01-15"),
    notes: "Payment received via bank transfer",
    createdAt: new Date("2025-01-15"),
    createdBy: "system",
    hasPromise: true,
    promiseToPayId: 1,
  },
  {
    id: 2,
    receiptNumber: "RCP-2025-002",
    customerId: 2,
    customerName: "XYZ Corporation",
    customerAccountNumber: "ACC-002",
    receiptDate: new Date("2025-01-20"),
    receivedAmount: 800.0,
    allocatedAmount: 0,
    unappliedAmount: 800.0,
    currency: "GBP",
    allocationStatus: "unallocated",
    reconciliationStatus: "pending",
    paymentMethod: "cheque",
    paymentReference: "CHQ-67890",
    financeSystemId: "FS-002",
    importedAt: new Date("2025-01-20"),
    notes: "Cheque payment",
    createdAt: new Date("2025-01-20"),
    createdBy: "system",
  },
];
